import React from "react";

// styling
import style from "./whatsapp.module.scss";
import { useTranslation, whatsappLink } from "../../i18n";

export default function Whatsapp() {
  const { t } = useTranslation();
  return (
    <div>
      <a
        href={whatsappLink(t.whatsapp.message)}
        target="_blank"
        className={`${style.pusat_bantuan} d-none d-md-flex align-items-center`}
        rel="noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt={t.whatsapp.alt}
          loading="lazy"
          className="img-fluid"
        />
      </a>
    </div>
  );
}
